import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/configuracion/configuracion-de-padrones/';

/**
 * GET Configuraciones de Padrones
 * param {object} params
 * @returns {Promise<object>}
 */
export const getConfiguracionesDePadrones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Configuracion de Padron
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConfiguracionDePadron = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Configuracion de Padrón
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionDePadron = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuracion de Padrón
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionDePadron = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Configuracion de Padron
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteConfiguracionDePadron = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
